import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BrandLogo } from '../components/BrandLogo'
import { useThemeMode } from '../components/ThemeModeProvider'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

// The centred card every signed-out page sits in: sign in, forgot
// password, the pages an emailed link opens.
export function AuthCard({ title, subtitle, children }: { title?: string; subtitle?: string; children: ReactNode }) {
  const { t } = useTranslation()
  const { mode } = useThemeMode()
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        bgcolor: 'background.default',
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={1} sx={{ mb: 3, alignItems: 'center', textAlign: 'center' }}>
            <BrandLogo onDark={mode === 'dark'} height={36} sx={{ maxWidth: '100%', mb: 1 }} />
            <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
              {title ?? t('app.intra')}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            ) : null}
          </Stack>
          {children}
        </CardContent>
      </Card>
    </Box>
  )
}
